import { api } from "./api";

export interface UserResponse {
  id: string;
  tenantId: string;
  nome: string;
  email: string;
  nivel: string;
  permissoes: string[];
  perfilId: string | null;
  ativo: boolean;
  ultimoAcesso: string | null;
  createdAt: string;
}

export interface CreateUserData {
  nome: string;
  email: string;
  senha: string;
  nivel: string;
  permissoes?: string[];
  perfilId?: string | null;
}

export interface UpdateUserData {
  nome?: string;
  email?: string;
  nivel?: string;
  permissoes?: string[];
  perfilId?: string | null;
  ativo?: boolean;
}

interface PaginatedUsers {
  data: UserResponse[];
  meta: { page: number; limit: number; total: number; totalPages: number };
}

export async function listUsers(params: {
  page?: number;
  limit?: number;
  search?: string;
}): Promise<PaginatedUsers> {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.search) query.set("search", params.search);

  const response = await api.get<UserResponse[]>(`/users?${query.toString()}`);
  return {
    data: response.data || [],
    meta: response.meta || { page: 1, limit: 10, total: 0, totalPages: 0 },
  };
}

export async function getUser(id: string): Promise<UserResponse> {
  const response = await api.get<UserResponse>(`/users/${id}`);
  return response.data!;
}

export async function createUser(data: CreateUserData): Promise<UserResponse> {
  const response = await api.post<UserResponse>("/users", data);
  return response.data!;
}

export async function updateUser(id: string, data: UpdateUserData): Promise<UserResponse> {
  const response = await api.put<UserResponse>(`/users/${id}`, data);
  return response.data!;
}

export async function deleteUser(id: string): Promise<void> {
  await api.delete(`/users/${id}`);
}
